import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const Icon: React.FC<SvgProps> = (props) => {
  const { width, height } = props
  return (
    <Svg width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none" {...props}>
      <g id="Base_Network_Logo 1" clipPath="url(#clip0_11990_27601)">
        <path
          id="Vector"
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#0052FF"
        />
        <path
          id="Vector_2"
          d="M12.0532 20.339C16.7042 20.339 20.4746 16.5751 20.4746 11.9322C20.4746 7.28923 16.7042 3.52539 12.0532 3.52539C7.64055 3.52539 4.0206 6.91325 3.66107 11.2255H14.7923V12.6388H3.66107C4.0206 16.951 7.64055 20.339 12.0532 20.339Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11990_27601">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default Icon
